module.exports = __webpack_public_path__ + "img/whatsapp.a2a6e939.png";